import { ApiHelper } from "shared/helpers/api";
import { getUrl, ROUTES } from "shared/api/urls";

export const getLoggedInUser = (): Promise<any> => {
    const url = getUrl(ROUTES.GET_CUSTOMER);
    return ApiHelper(url, { method: "POST" }).then((data: Response) => data.json());
};

export const logIn = (username: string, password: string, formKey: string) => {
    const url = getUrl(ROUTES.LOGIN);
    const body = { username, password, form_key: formKey };
    return ApiHelper(url, { method: "POST", body }).then((data: Response) => data.json());
};

interface IRegister {
    userName: string;
    firstName: string;
    lastName: string;
    email: string;
    password: string;
    formKey: string;
    offer_subscription?: number;
}

export const register = ({
    userName,
    firstName,
    lastName,
    email,
    password,
    formKey,
    offer_subscription,
}: IRegister) => {
    const url = getUrl(ROUTES.REGISTER);

    const body: { [key: string]: string | number } = {
        email,
        password,
        firstname: firstName,
        lastname: lastName,
        user_name: userName,
        password_confirmation: password,
        form_key: formKey,
    };
    if (offer_subscription !== undefined) {
        body.offer_subscription = offer_subscription;
    }

    return ApiHelper(url, { method: "POST", body }).then((data: Response) => data.json());
};

export const forgotPassword = (email: string) => {
    const url = getUrl(ROUTES.FORGOT_PASSWORD);
    const body = { isAjax: 1, email };
    return ApiHelper(url, { method: "POST", body }).then((data: Response) => data.json());
};
